import Text from '@/components/Text';
import { OldAppointmentProps, TherapyType } from '@/utils/types';
import dayjs from 'dayjs';
import { WithIcon } from '@/components/appointments/WithIcon';
import { SessionType } from '@/components/appointments/SessionType';
import TherapyTypeText from '@/components/appointments/TherapyTypeText';

type OldAppointmentCardProps = OldAppointmentProps & {
  therapyType: TherapyType;
};

// For display in reschedule and rematch flows
const OldAppointmentCard = ({
  startTime,
  isFirstAppointment,
  therapyType,
  appointmentType,
  previousLengthInMinutes,
  location,
}: OldAppointmentCardProps) => {
  return (
    <div className="border-1 border-grey-200 rounded w-full lg:w-[338px] h-fit space-y-4 p-4 mt-4 lg:mt-0 text-grey-800">
      <div>
        <Text.Serif.H4 className="pb-2 border-b-1 border-grey-200">
          Current appointment
        </Text.Serif.H4>
      </div>
      <WithIcon icon="Calendar">
        <Text.P>{dayjs(startTime).format('ddd MMM D [at] h:mmA')}</Text.P>
      </WithIcon>
      <TherapyTypeText
        therapyType={therapyType}
        isFirstAppointment={isFirstAppointment}
        appointmentType={appointmentType}
      />
      <WithIcon icon="Clock">
        <Text.P>{previousLengthInMinutes} minutes</Text.P>
      </WithIcon>
      <SessionType location={location} />
    </div>
  );
};

export default OldAppointmentCard;
